import React from 'react'
import { useLocation } from 'react-router-dom'

interface AppereanceProps {
  children: React.ReactNode
}

const Appereance = (props: AppereanceProps) => {
  const location = useLocation()
  const { pathname } = location
  const isEmailScreen = pathname.startsWith('/email')
  const isPaywall = pathname.startsWith('/paywall')

  return (
    <>
      {isEmailScreen && (
        <>
          <div className="absolute pointer-events-none w-[375px] h-[375px] top-[53px] left-0 bg-emailScreenBefore bg-no-repeat bg-[left_center] -z-[1]"></div>
          <div className="absolute pointer-events-none top-[calc(50%-83px)] -translate-y-1/2 right-0 w-full h-full bg-emailScreenAfter bg-no-repeat bg-[right_center] -z-[1]"></div>
        </>
      )}
      {isPaywall && (
        <>
          <div className="absolute pointer-events-none w-[375px] h-[500px] -bottom-[300px] right-0 bg-paywallBlueBefore bg-no-repeat bg-[right_bottom] -z-[1]"></div>
          <div className="absolute pointer-events-none w-full h-full -bottom-[835px] left-0 bg-paywallYellowBefore bg-no-repeat bg-[left_center]"></div>
          <div className="absolute pointer-events-none w-[375px] h-[375px] -bottom-[800px] right-0 bg-paywallYellowAfter bg-no-repeat bg-[right_bottom] -z-[1]"></div>
        </>
      )}
      {props.children}
    </>
  )
}

export default Appereance
